function a(t) {
  let n = "base:".concat(t, "-base,");
  return n += "input:".concat(t, "-input,"), n += "label:".concat(t, "-label,"), n += "prepend:".concat(t, "-prepend,"), n += "append:".concat(t, "-append"), n;
}
function r(t) {
  return "base:".concat(t, "-base");
}
function s(t) {
  let n = "base:".concat(t, "-base,");
  return n += "content:".concat(t, "-content"), n += "spinner:".concat(t, "-spinner"), n;
}
function e(t) {
  let n = "input:".concat(t, "-input,");
  return n += "label:".concat(t, "-label,"), n;
}
function p(t) {
  return "base:".concat(t, "-base,");
}
function o(t) {
  let n = "base:".concat(t, "-base,");
  return n += "trigger:".concat(t, "-trigger,"), n += "dropdown:".concat(t, "-dropdown"), n;
}
export {
  s as b,
  o as d,
  a as i,
  p as m,
  r as s,
  e as t
};
